
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CCCInterceptor } from './shared/helpers/ccc.interceptor';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APIService } from './shared/services/api.service';
import { SidemenuComponent } from './components/sidebar/sidemenu/sidemenu.component';
import { SublevelMenuComponent } from './components/sidebar/sidemenu/sublevel-menu.component';
import { DashboardLayoutComponent } from './components/layouts/dashboard/dashboard-layout.component';
import { FullpageLayoutComponent } from './components/layouts/fullpage/fullpage-layout.component';
import { NotificationService } from './shared/services/notification.service';
import { FooterComponent } from './components/sidebar/footer/footer.component';
import { LocalDataService } from './shared/services/local-data.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalizationService } from './shared/localization/localization.service';
import { LocalizationHub } from './shared/localization/localization.hub';
import { LocalizationLoader } from './shared/localization/localization.loader';
import { LocalizationParser } from './shared/localization/localization.parser';
import { MissingLocalizationHandler } from './shared/localization/missing-localization-handler';
import { LocalizationModule } from './shared/localization/localization.module';
import { CommonService } from './shared/services/common.service';
import { PhoneNumberSearchComponent } from './components/sidebar/sidemenu/phone-number-search/phone-number-search.component';
import { LoaderService } from './shared/services/loader.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { DialogService } from './shared/services/dialog.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AboutComponent } from './components/sidebar/sidemenu/about/about.component';
import { PushNotificationService } from './shared/services/push-notification.service';
import { ElevatorCallService } from './components/elevator-call/elevator-call.service';
import { AppConfigService } from './shared/services/app-config/app-config.service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ScreenPopService } from './components/screenpop/screenpop.service';
import { ConfirmLogoutComponent } from './components/sidebar/confirm-logout/confirm-logout.component';

export function initializeApp(appConfigService: AppConfigService) {
  const promise = appConfigService.load().then(() => {
    if (AppConfigService.settings && AppConfigService.settings.logging &&
      AppConfigService.settings.logging.appInsights) {
      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: AppConfigService.settings.appInsights.instrumentationKey,
          namePrefix: 'CCC_Client',
          enableAutoRouteTracking: true, // option to log all route changes,
          //enableCorsCorrelation: true
        }
      });
      appInsights.loadAppInsights();
      appInsights.trackPageView();
      AppConfigService.appMonitor = appInsights;
    }
  });
  return () => promise;
}

@NgModule({
  exports: [
    MatBadgeModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSidenavModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatStepperModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatTableModule,
    MatBottomSheetModule,
    MatFormFieldModule
  ]
})
export class MaterialModule { }

@NgModule({
  declarations: [
    AppComponent,
    SidemenuComponent,
    FooterComponent,
    SublevelMenuComponent,
    DashboardLayoutComponent,
    FullpageLayoutComponent,
    PhoneNumberSearchComponent,
    AboutComponent,
    SpinnerComponent,
    ConfirmLogoutComponent
  ],
  imports: [
    MaterialModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientXsrfModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizationModule,
    //////SharedModule.forRoot({ name: environment.name, API_BASE_URL: environment.apiUrl, CCC_BASE_URL: environment.cccUrl }),    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CCCInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfigService], multi: true },
    APIService,
    NotificationService,
    LocalDataService,
    LocalizationService,
    LocalizationLoader,
    LocalizationParser,
    MissingLocalizationHandler,
    LocalizationHub,
    CommonService,
    LoaderService,
    DialogService,
    PushNotificationService,
    ElevatorCallService,
    ScreenPopService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
